module.exports = __webpack_public_path__ + "static/media/prtlandingpagepic2.0f8e2d99.png";